import React, { createRef, useState } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import Auth from "../../../service/auth";
import GoogleLogin from "./google-login";
import Button from "@material-ui/core/Button";
import { Row, Col, Text } from "../../../comps";
import { Theme } from "../../../theme/theme-provider";

const FormWrapper = styled(Col)`
  width: 40%;
  height: 100%;
  color: #d7e0da;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 2%;
  padding-bottom: 2%;
  background: ${({ theme }) => theme.color.GRAY_3};
  box-shadow: 0 8px 16px 0 rgba(1, 1, 1, 1);
  justify-content: space-around;
  align-items: center;
`;

const Head = styled(Col)`
  width: 100%;
`;

const InputWrapper = styled(Col)`
  width: 100%;
  height: ${({ height }) => height};
  justify-content: space-around;
`;

const Input = styled.input`
  background: transparent;
  color: #d7e0da;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  outline: none;
  &:focus::placeholder {
    color: transparent;
    transition: opacity 2s;
  }
  &::placeholder {
    color: #d7e0da;
    opacity: 0.6;
    transition: opacity 2s;
  }
  &:-ms-input-placeholder {
    color: #d7e0da;
  }
  &::-ms-input-placeholder {
    color: #d7e0da;
  }
`;

const MODE = {
  LOGIN: 0,
  SIGNUP: 1,
  GOOGLE_STEP_2: 2,
  HOME: 3,
};

const Seperator = () => {
  const Line = (
    <div
      style={{
        background: Theme.color.GRAY_1,
        height: "1px",
        flexGrow: "1",
        marginLeft: "5%",
        marginRight: "5%",
      }}
    />
  );
  return (
    <Row alignItems={"center"} style={{ width: "100%" }}>
      {Line}
      <Text fontSize="18px" color={Theme.color.GRAY_1}>
        {"OR"}
      </Text>
      {Line}
    </Row>
  );
};

export default ({ mode, setMode, details, setDetails }) => {
  const suggestUsername = (email) => {
    return email && email.substr(0, email.indexOf("@"));
  };
  const isGoogleStep2 = mode === MODE.GOOGLE_STEP_2;
  const isSignup = mode === MODE.GOOGLE_STEP_2 || mode === MODE.SIGNUP;

  const refUsername = createRef(),
    refPassword = createRef(),
    refConfirm = createRef();

  const handleLogin = async () => {
    const username = refUsername.current.value,
      password = refPassword.current.value;
    const done = await Auth.guestLogin({ username, password });
    if (done) setMode(MODE.HOME);
  };

  const handleSignup = async () => {
    const username = refUsername.current.value;
    if (isGoogleStep2) {
      const { email, name, imageUrl, googleUserId } = details;
      const done = await Auth.googleSignup({
        email,
        name,
        imageUrl,
        googleUserId,
        username,
      });
      refUsername.current.value = "";
      if (done) {
        setMode(MODE.LOGIN);
      }
      return;
    }
    const password = refPassword.current.value,
      confirm = refConfirm.current.value;
    const done = await Auth.guestSignup({ username, password, confirm });
    if (done) setMode(MODE.LOGIN);
  };

  if (mode === MODE.HOME) return <Redirect push to={`/`} />;

  return (
    <FormWrapper>
      <Head>
        <Text fontSize="14px" color="#d7e0da">
          {isSignup ? `Signup` : `Login`}
        </Text>
        <Text
          marginTop="6px"
          fontSize="22px"
          color="#d7e0da"
        >{`Let's Get Started`}</Text>
      </Head>
      {isGoogleStep2 && (
        <Text
          width="100%"
          marginTop="6px"
          fontSize="14px"
          color="#d7e0da"
        >{`Choose username to complete signup with google (${details.name})`}</Text>
      )}
      <InputWrapper height={isGoogleStep2 ? "20%" : "40%"}>
        <Input
          type="username"
          placeholder="USERNAME"
          ref={refUsername}
          defaultValue={isGoogleStep2 ? suggestUsername(details.email) : ""}
        />
        {!isGoogleStep2 && (
          <Input type="password" placeholder="PASSWORD" ref={refPassword} />
        )}
        {isSignup && !isGoogleStep2 && (
          <Input
            type="password"
            placeholder="CONFIRM PASSWORD"
            ref={refConfirm}
          />
        )}
      </InputWrapper>
      <Button
        style={{ backgroundColor: Theme.color.BLUE_5, width: "100%" }}
        variant="contained"
        color="primary"
        onClick={isSignup ? handleSignup : handleLogin}
      >
        {isSignup ? `Signup` : `Login`}
      </Button>
      <Row alignItems="center">
        <Text fontSize="14px" color="#d7e0da">
          {isSignup ? `Already registered?` : `Don't have an account?`}
        </Text>
        <Button
          color="primary"
          onClick={() => {
            setMode(isSignup ? MODE.LOGIN : MODE.SIGNUP);
          }}
        >
          {isSignup ? `Login` : `Signup`}
        </Button>
      </Row>
      {!isGoogleStep2 && <Seperator />}
      {!isGoogleStep2 && (
        <GoogleLogin mode={mode} setMode={setMode} setDetails={setDetails} />
      )}
    </FormWrapper>
  );
};
